/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminMappingService {

    /**
     * export survey job definitions mapping
     * @returns any Success
     * @throws ApiError
     */
    public static exportJobMapping({
        requestBody,
    }: {
        requestBody: {
            prevSurveyJobProfileId?: string;
            nextSurveyJobProfileId?: string;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mapping/exportJobMapping',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * map survey job definitions
     * @returns any Success
     * @throws ApiError
     */
    public static mapSurveyJobDefinitions({
        prevSurveyJobDefinitionId,
        nextSurveyJobDefinitionId,
    }: {
        /**
         * Previous Survey Job Definition ID
         */
        prevSurveyJobDefinitionId: string,
        /**
         * Next Survey Job DefinitionId ID
         */
        nextSurveyJobDefinitionId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mapping/surveyJob/{prevSurveyJobDefinitionId}/{nextSurveyJobDefinitionId}',
            path: {
                'prevSurveyJobDefinitionId': prevSurveyJobDefinitionId,
                'nextSurveyJobDefinitionId': nextSurveyJobDefinitionId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * unmap survey job definitions
     * @returns any Success
     * @throws ApiError
     */
    public static unmapSurveyJobDefinitions({
        prevSurveyJobDefinitionId,
        nextSurveyJobDefinitionId,
    }: {
        /**
         * Previous Survey Job Definition ID
         */
        prevSurveyJobDefinitionId: string,
        /**
         * Next Survey Job DefinitionId ID
         */
        nextSurveyJobDefinitionId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/mapping/surveyJob/{prevSurveyJobDefinitionId}/{nextSurveyJobDefinitionId}',
            path: {
                'prevSurveyJobDefinitionId': prevSurveyJobDefinitionId,
                'nextSurveyJobDefinitionId': nextSurveyJobDefinitionId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * map survey job profiles
     * @returns any Success
     * @throws ApiError
     */
    public static mapSurveyJobProfiles({
        prevSurveyJobProfileId,
        nextSurveyJobProfileId,
    }: {
        /**
         * Previous Survey Job Profile ID
         */
        prevSurveyJobProfileId: string,
        /**
         * Next Survey Job Profile ID
         */
        nextSurveyJobProfileId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mapping/surveyJobProfile/{prevSurveyJobProfileId}/{nextSurveyJobProfileId}',
            path: {
                'prevSurveyJobProfileId': prevSurveyJobProfileId,
                'nextSurveyJobProfileId': nextSurveyJobProfileId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * unmap survey job profiles
     * @returns any Success
     * @throws ApiError
     */
    public static unmapSurveyJobProfiles({
        prevSurveyJobProfileId,
        nextSurveyJobProfileId,
    }: {
        /**
         * Previous Survey Job Profile ID
         */
        prevSurveyJobProfileId: string,
        /**
         * Next Survey Job Profile ID
         */
        nextSurveyJobProfileId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/mapping/surveyJobProfile/{prevSurveyJobProfileId}/{nextSurveyJobProfileId}',
            path: {
                'prevSurveyJobProfileId': prevSurveyJobProfileId,
                'nextSurveyJobProfileId': nextSurveyJobProfileId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get survey job profile mappings
     * @returns any[] Success
     * @throws ApiError
     */
    public static getSurveyJobProfileMappings({
        surveyJobProfileId,
    }: {
        /**
         * Survey Job Profile ID
         */
        surveyJobProfileId: string,
    }): CancelablePromise<any[]> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/mapping/surveyJobProfile/{surveyJobProfileId}',
            path: {
                'surveyJobProfileId': surveyJobProfileId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * mass map survey job definitions by file info
     * @returns any Success - File upload queued for async processing
     * @throws ApiError
     */
    public static massMapSurveyJobDefinitionsFile({
        sourceSurveyJobProfileId,
        targetSurveyJobProfileId,
        requestBody,
    }: {
        /**
         * Source Survey Job Profile ID
         */
        sourceSurveyJobProfileId: string,
        /**
         * Target Survey Job Profile ID
         */
        targetSurveyJobProfileId: string,
        requestBody: {
            file: {
                /**
                 * S3 key of the uploaded CSV file
                 */
                key: string;
                /**
                 * S3 bucket name
                 */
                bucket: string;
            };
        },
    }): CancelablePromise<{
        /**
         * ID of the created data loader for tracking progress
         */
        dataLoaderId: string;
        /**
         * Initial state of the data loader (typically 'ENQUEUED')
         */
        state: string;
        /**
         * Success message with instructions for tracking
         */
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mapping/surveyJob/mass/{sourceSurveyJobProfileId}/{targetSurveyJobProfileId}/file',
            path: {
                'sourceSurveyJobProfileId': sourceSurveyJobProfileId,
                'targetSurveyJobProfileId': targetSurveyJobProfileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * mass map survey job definitions
     * @returns any Success
     * @throws ApiError
     */
    public static massMapSurveyJobDefinitions({
        sourceSurveyJobProfileId,
        targetSurveyJobProfileId,
        requestBody,
    }: {
        /**
         * Source Survey Job Profile ID
         */
        sourceSurveyJobProfileId: string,
        /**
         * Target Survey Job Profile ID
         */
        targetSurveyJobProfileId: string,
        requestBody?: {
            recommendationType?: string;
            jobSubFamily?: Array<string>;
            jobLevel?: Array<string>;
            search?: string;
        },
    }): CancelablePromise<{
        mappingsCreated?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/mapping/surveyJob/mass/{sourceSurveyJobProfileId}/{targetSurveyJobProfileId}',
            path: {
                'sourceSurveyJobProfileId': sourceSurveyJobProfileId,
                'targetSurveyJobProfileId': targetSurveyJobProfileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
